import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Styled from '../../../lab/Styled';
import Icon from '../../../core/Icon';
import Grid from '@material-ui/core/Grid';
import NumericTextField from './TextField';
import NumericDropdown from './Dropdown';
import getDataProps from '../../../utils/propsUtil';
/**
 * @extends {React.Component<import('../types').FormInputNumericProps> }
 */

var NumericPicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumericPicker, _React$Component);

  function NumericPicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NumericPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NumericPicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChange = function (value) {
      _this.props.onChange(value);
    };

    _this.formatOptionLabel = function (value) {
      if (_this.props.format) return _this.props.format(value);
      return value;
    };

    _this.renderPicker = function (classes, theme) {
      var _this$props = _this.props,
          value = _this$props.value,
          options = _this$props.options,
          label = _this$props.label,
          width = _this$props.width,
          icon = _this$props.icon,
          tooltip = _this$props.tooltip,
          format = _this$props.format,
          parse = _this$props.parse,
          unspecifiedValue = _this$props.unspecifiedValue,
          showCurrentValueInDropdown = _this$props.showCurrentValueInDropdown;
      return React.createElement("div", Object.assign({
        className: classes.relative
      }, getDataProps(_this.props)), React.createElement(Grid, {
        container: true,
        direction: "row",
        spacing: 1,
        alignItems: "center",
        wrap: "nowrap"
      }, icon && React.createElement(Grid, {
        item: true
      }, React.createElement(Icon, {
        type: icon,
        label: tooltip,
        color: "action",
        className: classes.icon
      })), React.createElement(Grid, {
        item: true
      }, React.createElement("div", {
        className: classes.relative
      }, React.createElement(NumericTextField, {
        value: value,
        onChange: _this.onChange,
        label: label,
        width: width,
        format: format,
        parse: parse,
        unspecifiedValue: unspecifiedValue
      }), options.length ? React.createElement("div", {
        className: classes.dropdown
      }, React.createElement(NumericDropdown, {
        value: value,
        onChange: _this.onChange,
        options: options,
        formatLabel: _this.formatOptionLabel,
        showCurrentValueInDropdown: showCurrentValueInDropdown
      })) : null))));
    };

    return _this;
  }

  _createClass(NumericPicker, [{
    key: "render",
    value: function render() {
      return React.createElement(Styled, {
        theme: true,
        styles: styles,
        name: "ECNumericPicker"
      }, this.renderPicker);
    }
  }]);

  return NumericPicker;
}(React.Component);

var styles = function styles(theme) {
  return {
    relative: {
      position: 'relative'
    },
    dropdown: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      marginRight: -theme.spacing(1) * 2,
      marginBottom: -6
    },
    icon: {
      fontSize: '1rem',
      verticalAlign: 'middle'
    }
  };
};

NumericPicker.defaultProps = {
  value: null,
  options: [],
  label: 'Value',
  icon: 'numeric'
};
export default NumericPicker;